import styled from 'styled-components'

// Matches Select: borderless until hovered or focused, same height and radius
export const Input = styled.input`
  background-color: white;
  border: 2px solid transparent;
  border-radius: 8px;
  color: #0d1941;
  height: 3em;
  width: 100%;
  padding: 0 1.2em;
  font-size: 1em;
  font-weight: bold;
  font-family: inherit;

  &:hover {
    border-color: #529fce;
  }

  &:focus {
    outline: none;
    border-color: rgb(0 79 255);
    box-shadow: 0 0 0 3px rgb(0 79 255 / 25%);
  }

  &:invalid {
    border-color: red;
  }

  // A value the operator cannot change: still a box, so the page reads as one
  // column of values, but plainly not one to type in
  &:disabled {
    background-color: rgb(13 25 65 / 4%);
    border-color: transparent;
    color: rgb(13 25 65 / 55%);
  }
`
